<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,6.009999990463257C12,6.009999990463257,10,6.009999990463257,10,6.009999990463257C10,6.009999990463257,10,4.009999990463257,10,4.009999990463257C10,3.459999990463257,9.55,3.009999990463257,9,3.009999990463257C9,3.009999990463257,7,3.009999990463257,7,3.009999990463257C6.45,3.009999990463257,6,3.459999990463257,6,4.009999990463257C6,4.009999990463257,6,6.009999990463257,6,6.009999990463257C6,6.009999990463257,4,6.009999990463257,4,6.009999990463257C3.45,6.009999990463257,3,6.459999990463257,3,7.009999990463257C3,7.009999990463257,3,9.009999990463257,3,9.009999990463257C3,9.559999990463258,3.45,10.009999990463257,4,10.009999990463257C4,10.009999990463257,6,10.009999990463257,6,10.009999990463257C6,10.009999990463257,6,12.009999990463257,6,12.009999990463257C6,12.559999990463258,6.45,13.009999990463257,7,13.009999990463257C7,13.009999990463257,9,13.009999990463257,9,13.009999990463257C9.55,13.009999990463257,10,12.559999990463258,10,12.009999990463257C10,12.009999990463257,10,10.009999990463257,10,10.009999990463257C10,10.009999990463257,12,10.009999990463257,12,10.009999990463257C12.55,10.009999990463257,13,9.559999990463258,13,9.009999990463257C13,9.009999990463257,13,7.009999990463257,13,7.009999990463257C13,6.449999990463256,12.55,6.009999990463257,12,6.009999990463257C12,6.009999990463257,12,6.009999990463257,12,6.009999990463257Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SymbolCross',
} as DefineComponent
</script>
